
      var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconsError = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 97.006,
  height: 97.005,
  viewBox: "0 0 97.006 97.005"
}, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".icons-error_30e75ce18b5197d5__cls-1{fill:none;stroke:var(--theme-primary, #810ea9);stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;fill-rule:evenodd}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  id: "icons-error_30e75ce18b5197d5__icons-error_1_",
  transform: "translate(-5.046 -4.449)"
}, /*#__PURE__*/React.createElement("g", {
  id: "icons-error_30e75ce18b5197d5__Group_23",
  transform: "translate(7.546 6.949)"
}, /*#__PURE__*/React.createElement("path", {
  id: "icons-error_30e75ce18b5197d5__Path_10",
  d: "M60.878 35.222v-7.5l16.439 14.45-16.439 14.574v-7.5h-6.31s-7.985-.5-8.971 6.674a9.678 9.678 0 0 0 0 1.5v11.574a5.455 5.455 0 0 1-3.35 5.259 5.322 5.322 0 0 1-6.015-1.409l-.247-.275a5.493 5.493 0 0 1-1.33-3.575V47.721s-.222-6.774 4.732-9.874a9.273 9.273 0 0 1 3.351-1.325 14.6 14.6 0 0 1 2.687-.25",
  className: "icons-error_30e75ce18b5197d5__cls-1",
  transform: "translate(-5.453 -5.345)"
}), /*#__PURE__*/React.createElement("circle", {
  id: "icons-error_30e75ce18b5197d5__Ellipse_4",
  cx: 2.133,
  cy: 2.133,
  r: 2.133,
  fill: "var(--theme-primary, #810ea9)",
  transform: "translate(47.332 28.778)"
}), /*#__PURE__*/React.createElement("path", {
  id: "icons-error_30e75ce18b5197d5__Path_11",
  d: "m12.82 40.219 27.995-28a18.007 18.007 0 0 1 25.466 0l28 28a18.007 18.007 0 0 1 0 25.466l-28 27.995a18.007 18.007 0 0 1-25.466 0L12.82 65.685a18.007 18.007 0 0 1 0-25.466z",
  className: "icons-error_30e75ce18b5197d5__cls-1",
  transform: "translate(-7.546 -6.949)"
})))));

      const __svgRaw = "<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"97.006\" height=\"97.005\" viewBox=\"0 0 97.006 97.005\">\r\n    <defs>\r\n        <style>\r\n            .cls-1{fill:none;stroke:var(--theme-primary, #810ea9);stroke-linecap:round;stroke-linejoin:round;stroke-width:5px;fill-rule:evenodd}\r\n        </style>\r\n    </defs>\r\n    <g id=\"icons-error_1_\" transform=\"translate(-5.046 -4.449)\">\r\n        <g id=\"Group_23\" transform=\"translate(7.546 6.949)\">\r\n            <path id=\"Path_10\" d=\"M60.878 35.222v-7.5l16.439 14.45-16.439 14.574v-7.5h-6.31s-7.985-.5-8.971 6.674a9.678 9.678 0 0 0 0 1.5v11.574a5.455 5.455 0 0 1-3.35 5.259 5.322 5.322 0 0 1-6.015-1.409l-.247-.275a5.493 5.493 0 0 1-1.33-3.575V47.721s-.222-6.774 4.732-9.874a9.273 9.273 0 0 1 3.351-1.325 14.6 14.6 0 0 1 2.687-.25\" class=\"cls-1\" transform=\"translate(-5.453 -5.345)\"/>\r\n            <circle id=\"Ellipse_4\" cx=\"2.133\" cy=\"2.133\" r=\"2.133\" fill=\"var(--theme-primary, #810ea9)\" transform=\"translate(47.332 28.778)\"/>\r\n            <path id=\"Path_11\" d=\"M12.82 40.219l27.995-28a18.007 18.007 0 0 1 25.466 0l28 28a18.007 18.007 0 0 1 0 25.466l-28 27.995a18.007 18.007 0 0 1-25.466 0L12.82 65.685a18.007 18.007 0 0 1 0-25.466z\" class=\"cls-1\" transform=\"translate(-7.546 -6.949)\"/>\r\n        </g>\r\n    </g>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/icons-error.30e75ce18b5197d5b1939ce861152fc0.svg"),
        {
          React: SvgIconsError,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      